<template>
  <Component :is="pageComponent" :page-data="pageData">
    <Component :is="slotComponent" :page-data="pageData"/>
  </Component>
</template>

<script>

import LayoutInner from "@/mixins/LayoutInner";
import TariffsItemDesktop from "~/components/Page/Tariffs/TariffsItemDesktop.vue";
import TariffsItemMobile from "~/components/Page/Tariffs/TariffsItemMobile.vue";
import ChoosePaymentDesktop from "~/components/Desktop/Tariffs/ChoosePaymentDesktop.vue";
import ChoosePaymentMobile from "~/components/Mobile/Tariffs/ChoosePaymentMobile.vue";

export default {
  name: 'TariffsItemPage',
  mixins: [LayoutInner],
  async asyncData(context) {
    try {
      const pageData = await context.$axios.$get(`/tariffs/${context.route.params.item}`);
      if (!Object.keys(pageData.prices).includes(context.route.params.slug) || String(pageData.prices[context.route.params.slug].price) === '0') {
        context.error({statusCode: 404, message: 'Error: Prices not found for current tariff'});
      }
      return {pageData};
    } catch (e) {
      context.error({statusCode: 404, message: 'Axios exception: ' + e.message});
    }
  },
  data() {
    return {
      settedPeriod: '1 месяц',
      pageData: {},
    }
  },
  head() {
    return {
      title: `Тариф ${this.pageData.type} ${this.pageData.title} - ${this.settedPeriod}: сколько стоит провести вебинар - mts-link.ru`,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: 'Регистрация на тарифе ' + this.pageData.type + ' ' + this.pageData.title + ' на ' + this.settedPeriod + ' ✓  Сколько стоит провести онлайн вебинар. ✓  Цена. ✓  Стоимость. ✓  Платформа  МТС Линк - лидер на рынке. ✓  Онлайн трансляции под ключ. Регистрируйтесь!',
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: '',
        },
      ],
    };
  },
  computed: {
    pageComponent() {
      return this.$device.isDesktop ? TariffsItemDesktop : TariffsItemMobile;
    },
    slotComponent() {
      return this.$device.isDesktop ? ChoosePaymentDesktop : ChoosePaymentMobile;
    },
  },
  created() {
    const slug = this.$route.params.slug;
    this.settedPeriod = slug + this.setEndingPeriod(slug);
  },
  methods: {
    setEndingPeriod(name) {
      switch (String(name)) {
        case '1':
          return ' месяц';
        case '2':
        case '3':
        case '4':
          return ' месяца';
        default:
          return ' месяцев';
      }
    },
  },
}
</script>
